import React from "react";
import { cn } from "@/lib/utils";

export function BrandMark({ className, invert = false }) {
  const notches = Array.from({ length: 24 }, (_, i) => i);
  const round = (n) => Number(n.toFixed(3));
  return (
    <svg viewBox="0 0 48 48" fill="none" className={className} role="img" aria-label="Aureus Notariat">
      <defs>
        <linearGradient id="aureus-token" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="oklch(0.2 0.02 260)" />
          <stop offset="100%" stopColor="oklch(0.14 0.02 260)" />
        </linearGradient>
        <linearGradient id="aureus-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="oklch(0.86 0.09 82)" />
          <stop offset="55%" stopColor="oklch(0.76 0.09 82)" />
          <stop offset="100%" stopColor="oklch(0.6 0.09 82)" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="12" fill="url(#aureus-token)" />
      <rect x="1" y="1" width="46" height="46" rx="12" fill="none" stroke="url(#aureus-gold)" strokeOpacity={invert ? 0.55 : 0.35} strokeWidth="1.25" />
      <g stroke="url(#aureus-gold)" strokeWidth="1.4" strokeLinecap="round" opacity="0.7">
        {notches.map((i) => {
          const angle = (i / notches.length) * Math.PI * 2;
          const r1 = 17.4, r2 = 18.8, cx = 24, cy = 24;
          return (
            <line key={i} x1={round(cx + Math.cos(angle) * r1)} y1={round(cy + Math.sin(angle) * r1)} x2={round(cx + Math.cos(angle) * r2)} y2={round(cy + Math.sin(angle) * r2)} />
          );
        })}
      </g>
      <circle cx="24" cy="24" r="15.2" fill="none" stroke="url(#aureus-gold)" strokeWidth="1.4" opacity="0.85" />
      <g fill="none" stroke="url(#aureus-gold)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16.5 33 24 14l7.5 19" />
        <path d="M19.6 26.4h8.8" />
      </g>
      <circle cx="24" cy="13" r="2.1" fill="url(#aureus-gold)" />
    </svg>
  );
}

export function BrandLogo({ className, invert = false, showWordmark = true }) {
  return (
    <span className={cn("flex items-center gap-3", className)}>
      <BrandMark invert={invert} className="h-9 w-9 shrink-0" />
      {showWordmark && (
        <span className="flex flex-col leading-none">
          <span className={cn("font-serif text-base font-semibold tracking-tight", invert ? "text-sidebar-foreground" : "text-foreground")}>
            Aureus Notariat
          </span>
          <span className={cn("mt-1 text-[10px] uppercase tracking-[0.2em]", invert ? "text-sidebar-foreground/60" : "text-muted-foreground")}>
            Treuhand &amp; Zahlungsvermittlung
          </span>
        </span>
      )}
    </span>
  );
}
